/**
 * Universal Socket.IO Client
 * ──────────────────────────
 * Singleton socket connection that picks up the JWT token from localStorage
 * (same source as src/api/axios.js). Auto-reconnects. Safe to call
 * connectSocket()/disconnectSocket() multiple times.
 *
 * Reusable: only thing project-specific here is the localStorage key
 * ('giggs_tokens') and the token field names — adjust if needed.
 */

import { io } from 'socket.io-client';


const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'https://giggs-backend-ff5df60a245f.herokuapp.com/';

const TOKEN_STORAGE_KEY = 'giggs_tokens';

let socket = null;

const readToken = () => {
  const raw = localStorage.getItem(TOKEN_STORAGE_KEY);
  if (!raw) return null;
  try {
    const t = JSON.parse(raw);
    return t.accessToken || t.access_token || t.token || t.access || null;
  } catch {
    return null;
  }
};

export const connectSocket = () => {
  if (socket && socket.connected) return socket;

  const token = readToken();
  if (!token) {
    console.warn('[socket] No token available — skipping connect');
    return null;
  }

  // If we already built a socket but it's disconnected, just reconnect it.
  if (socket) {
    socket.auth = { token };
    socket.connect();
    return socket;
  }



  socket = io(SOCKET_URL, {
    auth: { token },
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    autoConnect: true,
  });

  socket.on('connect', () => console.log('[socket] connected:', socket.id));
  socket.on('disconnect', (reason) =>
    console.log('[socket] disconnected:', reason)
  );
  socket.on('connect_error', (err) =>
    console.error('[socket] connect_error:', err.message)
  );

  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.removeAllListeners();
    socket.disconnect();
    socket = null;
  }
};

export const getSocket = () => socket;